import { apiService } from './apiService'; // Assuming apiService is correctly se  // Session check start (debug removed)
import { logger } from '../utils/logger';

export const loginUser = async (username, password) => {
  logger.info('[FrontendAuthService-loginUser] INIZIO tentativo login per:', username);
  try {
    const response = await apiService.post('/autenticazione/login', { username, password });
    logger.info('[FrontendAuthService-loginUser] Login completato con successo per:', username, {
      hasToken: !!response.token,
      expiresAt: response.expiresAt,
      userId: response.user?.id
    });
    return response;
  } catch (error) {
    logger.error('[FrontendAuthService-loginUser] Login fallito per:', username, error);
    throw error;
  }
};

export const registerUser = async (userData) => {
  logger.info('[FrontendAuthService-registerUser] INIZIO tentativo registrazione per:', userData.username);
  try {
    const response = await apiService.post('/autenticazione/register', userData);
    logger.info('[FrontendAuthService-registerUser] Registrazione completata per:', userData.username);
    return response;
  } catch (error) {
    logger.error('[FrontendAuthService-registerUser] Registrazione fallita per:', userData.username, error);
    throw error;
  }
};

// NUOVO: Refresh della sessione
export const refreshSession = async () => {
  const startTime = Date.now();
  logger.info('[FrontendAuthService-refreshSession] INIZIO refresh sessione.');
  
  try {
    const response = await apiService.post('/auth/refresh', {});
    const duration = Date.now() - startTime;
    
    logger.info('[FrontendAuthService-refreshSession] Refresh sessione completato con successo in ' + duration + 'ms:', {
      expiresAt: response.expiresAt,
      username: response.user?.username,
      userId: response.user?.id,
      hasNewToken: !!response.token
    });
    return response;
  } catch (error) {
    const duration = Date.now() - startTime;
    logger.error('[FrontendAuthService-refreshSession] Refresh sessione fallito dopo ' + duration + 'ms:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message
    });
    throw error;
  }
};

export const logoutUser = async () => {
  // Frontend logout might not need to call backend if JWTs are stateless
  // and client just deletes the token.
  // However, if you want to invalidate on server (e.g. SKE_Sessioni), call backend.
  logger.info('[FrontendAuthService-logoutUser] INIZIO logout utente.');
  try {
    // No need to pass token in body, it's in Authorization header
    const response = await apiService.post('/autenticazione/logout', {});
    logger.info('[FrontendAuthService-logoutUser] Logout completato con successo.');
    return response;
  } catch (error) {
    logger.warn('[FrontendAuthService-logoutUser] Logout API call fallito, procedo con logout client-side:', {
      status: error.response?.status,
      message: error.message
    });
    return null; // Or handle error as needed
  }
};

export const checkSession = async () => {
  const startTime = Date.now();
  const token = localStorage.getItem('authToken');
  
  logger.info('[FrontendAuthService-checkSession] INIZIO verifica sessione.', {
    hasTokenInStorage: !!token,
    tokenPrefix: token ? token.substring(0, 15) + '...' : 'NULL'
  });
  
  // The token is automatically added by the axios interceptor
  try {
    const response = await apiService.get('/auth/session'); // Or '/auth/check' if you changed it
    const duration = Date.now() - startTime;
    
    // Session check completed (debug removed)
    
    return response;
  } catch (error) {
    const duration = Date.now() - startTime;
    logger.error('[FrontendAuthService-checkSession] Verifica sessione fallita dopo ' + duration + 'ms:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message,
      hasTokenInStorage: !!token
    });
    throw error;
  }
};